import { Component } from 'react';
import Header from '../../Header';
import MessageLink from '../../MessageLink';
import Footer from '../../Footer';
import Lgpd from '../../Lgpd';
import ErrorBoundary from '../../ErrorHandler/ErrorBoundary';
import Calculadora from '../../Calculadora/Calculadora';
import PageDescriptionFootnote from '../../PageDescription/Footnote';
import InfoComponent from '../InfoComponent';

class CalculadoraPage extends Component {
	render() {
		return (
			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>
				<main>
					
					<InfoComponent image={"calculadora-de-aporte"} page={'calculadora-de-aporte'}></InfoComponent>		
					
					<section className="page-description mb-9">
						<div className="container">
							<div className="row justify-content-center">
								<div key="{item.Id}" className="col-lg-10">
									<div className="page-description__midias">
										<PageDescriptionFootnote />
									</div>
								</div>
							</div>
						</div>
					</section>
					<br></br><br></br>
					{/* Content page */}
					<div className="_the-content page-planos pb-10">
						<div className='container'>
							<div className="row justify-content-center">

								<div className="col-md-10">
									<div className="row">
										<ErrorBoundary>
											<Calculadora></Calculadora>
										</ErrorBoundary>
									</div>
								</div>
							</div>
						</div>
					</div>
				</main>
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default CalculadoraPage;